module.exports = __webpack_public_path__ + "img/login-v2.77197015.svg";